import React from 'react';
import 'dayjs/locale/es';
import { capitalize } from '../../../utilities/functions';
import dayjs from 'dayjs';

dayjs.locale('es');

export type DateRange = {
  from: string
  to: string
}

export type DaysRange = {
  id: `days${number}`
  label: string
  range: DateRange
}

export type MonthRange = {
  id: `months${number}`
  label: string
  range: DateRange
}

export type CalendarRange = {
  id: 'calendar'
  label?: string
  range: DateRange
}

export const getLastNDaysRange = (n: number, include_today: boolean = false): DaysRange => {
  let to = dayjs()
  const from = to.subtract(n, 'day')

  to = to.subtract(include_today ? 0 : 1, 'day')

  return ({
    id: `days${n}`,
    label: `Ultimos ${n} días`,
    range: {
      from: from.format('YYYY-MM-DD'),
      to: to.format('YYYY-MM-DD')
    }
  }
  )
}

export const getLastNMonthsRange = (n: number): MonthRange[] => {
  let res: MonthRange[] = []

  const now = dayjs()

  for (let i: number = 0; i < n; i++) {
    const from = now.subtract(i, 'month').set('date', 1)
    const to = from.set('date', from.daysInMonth())

    res.push({
      id: `months${i + 1}`,
      label: capitalize(from.format('MMMM')),
      range: { from: from.format('YYYY-MM-DD'), to: to.format('YYYY-MM-DD') }
    })

  }
  return res
}

export const getDateRangeValues = (startDate: dayjs.Dayjs, endDate: dayjs.Dayjs, freq: 'day' | 'month' = 'day'): dayjs.Dayjs[] => {
  const dates: dayjs.Dayjs[] = [];

  let currentDate = startDate;

  while (currentDate.isBefore(endDate) || currentDate.isSame(endDate, freq)) {
    dates.push(currentDate)
    currentDate = currentDate.add(1, freq)
  }

  return dates


}

export const decimalToTime = (decimal: number) => {
  const hours = Math.floor(decimal);
  const minutes = Math.round((decimal - hours) * 60);
  return `${hours}:${minutes.toString().padStart(2, '0')}`;
}

